var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"force-scan",class:{ 'top-left': _vm.fixed },attrs:{"src":_vm.brandAsset(_vm.startScan, _vm.startScanSanne),"alt":"Scan"},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }